import { useMyOrganizations } from "@/api/organizations/useMyOrganizations";
import { useClubFeed } from "@/api/club/useClub";
import { useOrgPermissions } from "@/auth/orgPermissions";
import { routes } from "@/constants/routes";
import { useNetworkStatus } from "@/network/NetworkContext";
import { useTheme } from "@/theme/ThemeProvider";
import { ClubFeed } from "@/ui/components/club/ClubFeed";
import { ClubSection } from "@/ui/components/ClubSection";
import { EmptyState } from "@/ui/components/EmptyState";
import { HeaderAction } from "@/ui/components/HeaderAction";
import { Screen } from "@/ui/components/Screen";
import { ErrorState, LoadingState } from "@/ui/components/StateViews";
import { useRouter } from "expo-router";
import { PlusIcon } from "phosphor-react-native";
import React, { useEffect } from "react";
import { RefreshControl } from "react-native";

const OFFLINE_HINT =
  "Der Vereinsbereich benötigt eine Internetverbindung.";

export default function ClubIndexScreen() {
  const { theme } = useTheme();
  const router = useRouter();
  const { isOnline } = useNetworkStatus();
  const { organizations, loading: orgLoading } = useMyOrganizations();
  const org = organizations[0];
  const permissions = useOrgPermissions(org?.id);
  const { items, loading, error, refetch } = useClubFeed(
    org?.id,
    isOnline && !!org?.id
  );

  useEffect(() => {
    if (error) console.error("club feed", error);
  }, [error]);

  if (!isOnline) {
    return (
      <Screen title="Verein">
        <EmptyState
          title="Offline"
          hint={OFFLINE_HINT}
        />
      </Screen>
    );
  }

  if (orgLoading || (loading && !items.length)) {
    return (
      <Screen title="Verein">
        <LoadingState message="Vereinsfeed laden…" />
      </Screen>
    );
  }

  if (!org) {
    return (
      <Screen title="Verein">
        <ErrorState message="Keine aktive Vereinsmitgliedschaft." />
      </Screen>
    );
  }

  return (
    <Screen
      title="Verein"
      scroll
      refreshControl={
        <RefreshControl
          refreshing={loading}
          onRefresh={() => void refetch()}
          tintColor={theme.color.primary}
        />
      }
      contentStyle={{ paddingBottom: theme.space.xxl, gap: theme.space.lg }}
    >
      <ClubSection
        orgName={org.name}
        roles={permissions.roles}
        showSuperadminChip={permissions.isReadOnlySuperadmin}
        active="posts"
        onSelect={(tab) => {
          if (tab === "members") {
            router.replace(routes.tenant.members(org.id) as never);
          }
        }}
        headerAction={
          <HeaderAction
            icon={PlusIcon}
            label="Neuer Beitrag"
            onPress={() => router.push(routes.myClubNew as never)}
          />
        }
      >
        {error ? (
          <ErrorState
            message="Der Feed konnte nicht geladen werden."
            onRetry={() => void refetch()}
            retryLabel="Erneut laden"
          />
        ) : (
          <ClubFeed items={items} />
        )}
      </ClubSection>
    </Screen>
  );
}
